import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import { Colors, getColorWithOpacity } from '@rentguru/commons-utils';

export const StyledCheckbox = withStyles({
  root: {
    color: Colors.BLUE_GREY,
    '&$checked': {
      color: Colors.DODGER_BLUE,
      '&:hover': {
        backgroundColor: getColorWithOpacity(Colors.DODGER_BLUE, 10),
      },
    },
    '&$disabled': {
      color: getColorWithOpacity(Colors.BLUEY, 80),
    },
    '&:hover': {
      backgroundColor: getColorWithOpacity(Colors.DODGER_BLUE, 10),
    },
  },
  checked: {},
  disabled: {},
})(Checkbox);
